import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import MineOwn from '../components/forms/MineOwn'


const MineOwner = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Mine Owner/Permit Holder Entry' text='Please complete the registration form' />
            <MineOwn />
            <Banner />
            <Footer />
        </div>
    )
}

export default MineOwner;
